<template>
  <div class="mb-2">
    <div
      v-if="question?.show_subject !== false"
      class="flex items-start"
      :class="[!question?.description ? 'mb-1' : '']"
    >
      <p
        v-if="!question?.is_html_subject"
        class="text-dark-blue"
      >
        {{ subject }}
      </p>
      <div
        v-else
        class="text-sm"
        v-html="question?.subject"
      />
      <slot />
    </div>
    <p
      v-if="question?.description"
      class="mb-1 text-xxs font-bold uppercase text-gray-over-dark"
    >
      {{ question.description }}
    </p>
    <textarea
      v-model="answer"
      placeholder=""
      class="textarea-field mb-4 h-40 w-full rounded-md border border-transparent bg-off-white p-2 px-3 text-sm text-dark-gray placeholder-gray-over-dark hover:border-placeholder-gray focus:border-placeholder-gray focus:bg-white"
      name="message"
      @input="handleChange"
    />
  </div>
</template>

<script>
export default {
  name: 'TextArea',
  props: {
    question: Object,
    question_id: Number,
    subject: String,
    currentTaxFormId: Number,
    onboardingPacketId: Number,
    setTaxAnswers: Function,
    toggleRequired: Function,
    required: Boolean,
    currentAnswerObject: [Object, Boolean],
    conditional_children: Array,
  },
  emits: ['child-check'],
  data() {
    return {
      answer: '',
    };
  },
  created() {
    if (this.currentAnswerObject && this.currentAnswerObject !== false) {
      this.answer = this.currentAnswerObject?.string_value;
      this.presetSavedAnswer();
    }
  },
  methods: {
    handleChange(e) {
      let body = null;
      if (this.answer?.length > 0) {
        body = {
          onboarding_packet_id: this.onboardingPacketId,
          tax_form_id: this.currentTaxFormId,
          tax_question_id: this.question_id,
          string_value: e.target.value,
        };
      }

      this.setTaxAnswers(body);
      if (this.required) {
        this.answer?.length > 0
          ? this.toggleRequired(this.question_id, true)
          : this.toggleRequired(this.question_id, false);
      }
      this.emitForComparison(e.target.value);
    },
    emitForComparison(value) {
      if (this.conditional_children?.length > 0) {
        this.conditional_children.forEach((child) => {
          if (child?.evaluation_js?.length > 0 && child?.tax_question_id > 0) {
            this.$emit(
              'child-check',
              child.tax_question_id,
              value,
              child.evaluation_js,
              child.is_shown_by_default,
              child.is_required
            );
          }
        });
      }
    },
    presetSavedAnswer() {
      let body = {
        onboarding_packet_id: this.onboardingPacketId,
        tax_form_id: this.currentTaxFormId,
        tax_question_id: this.question_id,
        string_value: this.answer,
      };

      this.setTaxAnswers(body);
      if (this.required) {
        this.answer
          ? this.toggleRequired(this.question_id, true)
          : this.toggleRequired(this.question_id, false);
      }
      this.emitForComparison(this.answer);
    },
  },
};
</script>
